import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useParams, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { LocaleProvider } from './context/LocaleContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import TopBar from './components/TopBar';
import Footer from './components/Footer';
import ConsentBanner from './components/ConsentBanner';
import AdminApp from './admin/AdminApp';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Sports from './pages/Sports';
import Brand from './pages/Brand';
import Product from './pages/Product';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Checkout from './pages/Checkout';
import Orders from './pages/Orders';
import LegalPage from './pages/LegalPage';
import './App.css';

function CategoryToSportsRedirect() {
  const { categorySlug } = useParams();
  const slug =
    categorySlug === 'f1' || categorySlug === 'formula-1'
      ? 'formula-series'
      : categorySlug;
  return <Navigate to={`/sports/${slug}`} replace />;
}

function FormulaSeriesRedirect() {
  return <Navigate to="/sports/formula-series" replace />;
}

function StorefrontApp() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className={`app-shell${isHome ? ' app-shell--home' : ''}`}>
      <TopBar />
      <div className="app-shell-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:categorySlug" element={<Shop />} />
          <Route path="/category/:categorySlug" element={<CategoryToSportsRedirect />} />
          <Route path="/sports/f1" element={<FormulaSeriesRedirect />} />
          <Route path="/sports/formula-1" element={<FormulaSeriesRedirect />} />
          <Route path="/sports/:sportSlug" element={<Sports />} />
          <Route path="/brands/:brandSlug" element={<Brand />} />
          <Route path="/product/:productId" element={<Product />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<LegalPage />} />
          <Route path="/terms" element={<LegalPage />} />
          <Route path="/shipping" element={<LegalPage />} />
          <Route path="/returns" element={<LegalPage />} />
          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
      <Footer />
      <ConsentBanner />
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
    );
  }

  return <StorefrontApp />;
}

function App() {
  return (
    <AuthProvider>
      <LocaleProvider>
        <CartProvider>
          <ToastProvider>
            <Router>
              <AppContent />
            </Router>
          </ToastProvider>
        </CartProvider>
      </LocaleProvider>
    </AuthProvider>
  );
}

export default App;
